var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoinAsk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.4761 10H15.8095C13.6952 10 11.9999 11.7143 11.9999 13.8095V40.4762C11.9999 42.5714 13.6952 44.2857 15.8095 44.2857H23.4285L29.1428 50L34.8571 44.2857H42.4761C44.5714 44.2857 46.2857 42.5714 46.2857 40.4762V13.8095C46.2857 11.7143 44.5714 10 42.4761 10ZM42.4761 40.4762H33.2761L32.1523 41.6L29.1428 44.6095L26.1142 41.581L25.0095 40.4762H15.8095V13.8095H42.4761V40.4762ZM27.238 34.7619H31.0476V38.5714H27.238V34.7619ZM29.1428 19.5238C31.238 19.5238 32.9523 21.2381 32.9523 23.3333C32.9523 27.1429 27.238 26.6667 27.238 32.8571H31.0476C31.0476 28.5714 36.7618 28.0952 36.7618 23.3333C36.7618 19.1238 33.3523 15.7143 29.1428 15.7143C24.9333 15.7143 21.5237 19.1238 21.5237 23.3333H25.3333C25.3333 21.2381 27.0476 19.5238 29.1428 19.5238Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoinAsk);
export default __webpack_public_path__ + "static/media/poin-ask.567a0f86.svg";
export { ForwardRef as ReactComponent };